import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import {
  Router,
  NavigationEnd,
  Event as NavigationEvent,
} from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { Location } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { CommonService } from 'src/app/shareModule/services/common.service';

@Component({
  selector: 'app-forum',
  templateUrl: './forum.component.html',
  styleUrls: ['./forum.component.scss'],
})
export class ForumComponent implements OnInit, OnDestroy {
  private destroy$ = new BehaviorSubject<void>(null);
  navLink: boolean = false;
  private scrollPosition: [number, number] = [0, 0];
  url: any;
  constructor(
    private sharedService: SharedService,
    private router: Router,
    @Inject('WINDOW') private window: any,
    private location: Location,
    private commonService: CommonService
  ) { }
  goBack() {
    this.commonService.goBack();
  }
  ngOnInit(): void {
    this.url = this.router.url;
    this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationEnd) {
        this.url = event.urlAfterRedirects;
        this.window?.scrollTo(this.scrollPosition[0], this.scrollPosition[1]);
      }
    });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openTopic() {
    this.sharedService.triggerInitTopic({
      type: 'topic',
    });
  }
  openMenu() {
    this.sharedService.triggerInitTopic({
      type: 'menu',
    });
  }
  onNavigate(url) {
    this.scrollPosition = [this.window?.scrollX, this.window?.scrollY];
  }
  onSearch(e) {
    this.sharedService.triggerInitTopic({
      type: 'search',
      value: e.target.value,
    });
  }
}
